var n = function(i) {
  var e = !1;
  window.addEventListener("pagehide", function() {
    e || (e = !0, i());
  }), document.addEventListener("visibilitychange", function() {
    if (document.visibilityState == "hidden") {
      if (e)
        return;
      e = !0, i();
    } else
      e = !1;
  });
};
export {
  n as onPageLeave
};
//# sourceMappingURL=index80.js.map
